(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[746],{

/***/ 84160:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(74628);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ MetaHead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/home.ts
var homeBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"Главная\",\n      \"item\": \"https://bile-bile.kz/\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/org.ts
var orgSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"Organization\",\n  \"name\": \"Bile-bile\",\n  \"logo\": \"https://bile-bile.kz/og-image.png\",\n  \"url\": \"https://bile-bile.kz/\",\n  \"address\": {\n    \"@type\": \"PostalAddress\",\n    \"addressCountry\": \"Kazakhstan\"\n  },\n  \"sameAs\": []\n}";

;// CONCATENATED MODULE: ./schemas/org/web.ts
var webSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"WebSite\",\n  \"url\": \"https://bile-bile.kz/\",\n  \"potentialAction\": {\n    \"@type\": \"SearchAction\",\n    \"target\": \"https://bile-bile.kz/search?origin={search_term_string}\",\n    \"query-input\": \"required name=search_term_string\"\n  }\n}";

;// CONCATENATED MODULE: ./schemas/org/faq.ts
var faqSchema = "{\n      \"@context\": \"http://schema.org/\",\n      \"@type\": \"FAQPage\",\n      \"mainEntity\": [\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Хочу купить билет для ребёнка. Сколько стоит детский ж/д билет на поезд?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Дети до 7 лет путешествуют на поезде бесплатно без предоставления отдельного места. Если детей до 7 лет двое или более, необходимо купить детский билет.  Для детей от 7 до 15 лет действует скидка в размере 50% от цены взрослого билета.  Для покупки детского билета понадобится свидетельство о рождении, удостоверяющее личность ребёнка. Если ребёнок едет не с родителями, нужно оформить доверенность на сопровождение.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я хочу забронировать билет на поезд. Сколько времени действует бронь?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Бронь на ж/д билет действует 30 минут. 15 минут на ввод данных пассажира и 15 минут на оплату.  После этого нужно заново забронировать билет.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"На что обратить внимание при выборе ж/д билета?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Рекомендуем обратить внимание на несколько важных моментов при бронировании ж/д билетов:  \xb7 Тип вагона: плацкарт, купе  От выбранного типа зависит стоимость билета и уровень комфорта во время поездки;  \xb7 Выбор места.  Вы можете выбрать любое место в вагоне. В плацкартных вагонах места у туалета с 33 до 38 номера, а в купейных -- с 33 по 36. Во всех поездах нижние полки -- это нечетные места, а верхние -- четные.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я сделал ошибку в личных данных при покупке ж/д билета. Что делать?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Если вы допустили ошибку в билете на поезд, сделайте возврат билета c главной страницы Bile-Bile → Возврат билета и оформите новый.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Какое максимальное количество билетов я могу приобрести в рамках оформления заказа?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"В рамках оформления заказа допускается приобретение 12 билетов. При необходимости увеличения количества билетов, необходимо оформить новый заказ\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Какое подтверждение я получу после оплаты ж/д билета?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \" Подтверждением заказа служит электронный билет, который вы получите после оплаты брони.  Мы также отправим билет на электронную почту или посредством SMS на реквизиты указанные при заказе билета  Электронный билет всегда доступен с главной страницы Bile-Bile → Печать билета и оформите новый\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Необходимо ли иметь при себе билет при посадке в поезд?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"На наши поезда осуществляется посадка пассажира без необходимости предъявления билета (для резидентов РК по бар-коду удостоверения личности, на которое оформлялся заказ билета)\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я сделал возврат ж/д билета, купленного на Bile-Bile. Когда мне вернут деньги?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Возврат платежей по Билетам, приобретенным по платежным картам, производится на банковский карт-счет, с которого производилась оплата, в течение 5 (пяти) рабочих дней с момента получения подтверждения возврата билета.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Как мне вернуть билет, если его за меня купил кто-то другой?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Возврат билета оформляется c главной страницы Bile-Bile → Возврат билета, по реквизитам оформителя.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я собираюсь вернуть неиспользованный билет, на что обратить внимание?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Формирование запроса на возврат Билета  Возврат Билета производится круглосуточно через функционал Сайта. Возможно производить возврат одного или нескольких Билетов в Заказе.  Для возврата неиспользованного Билета необходимо пройти в раздел \xabВозврат билета\xbb, авторизоваться посредством указания электронного адреса или телефона, указанного во время оформления Билета и следовать дальнейшим инструкциям.  Возврат платежей по Билетам, приобретенным по платежным картам, производится на банковский карт-счет, с которого производилась оплата, в течение 5 (пяти) рабочих дней с момента получения подтверждения возврата Билета.  При оформлении возврата билета, сумма, уплаченная за Дополнительные услуги, возврату не подлежит.  Порядок удержания сумм при возврате Билета  За неиспользованные Билеты и несостоявшуюся вследствие этого перевозку багажа Перевозчик возвращает Пассажиру деньги в следующих случаях:  \xb7 не позднее, чем за 24 часа до отправления поезда - полную стоимость проезда;  \xb7 менее чем за 24 часа, но не позднее, чем за 6 (шесть) часов до отправления поезда - стоимость билета и 50 % (пятидесяти) стоимости плацкарты;  \xb7 менее чем за 6 часов до отправления и не более 1 (одного) часа после отправления поезда - стоимость билета, при этом удерживается вся стоимость плацкарты, но не более 30% от стоимости проезда.  По истечении 1 (одного) часа после отправления поезда возврат Билета не производится, денежные средства не возвращаются.\"\n          }\n        }\n      ]\n    }";

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/faq.ts
var faqBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"FAQ\",\n      \"item\": \"https://bile-bile.kz/faq\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/covid.ts
var covidBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"COVID-19\",\n      \"item\": \"https://bile-bile.kz/covid\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/contacts.ts
var contactsBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"Контакты\",\n      \"item\": \"https://bile-bile.kz/contacts\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/search.ts
var buildSearchSchema = function(param) {
    var origin = param.origin, destination = param.destination, departureTime = param.departureTime, arrivalTime = param.arrivalTime;
    return "{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"TrainReservation\",\n  \"reservationId\": \"AB3XY2\",\n  \"reservationStatus\": \"https://schema.org/ReservationConfirmed\",\n  \"reservationFor\": {\n    \"@type\": \"TrainTrip\",\n    \"departureStation\": {\n      \"@type\": \"TrainStation\",\n      \"name\": \"".concat(origin, "\"\n    },\n    \"departureTime\": \"").concat(departureTime, "\",\n    \"arrivalStation\": {\n      \"@type\": \"TrainStation\",\n      \"name\": \"").concat(destination, "\"\n    },\n    \"arrivalTime\": \"").concat(arrivalTime, "\"\n  }\n}");
};

;// CONCATENATED MODULE: ./schemas/org/landing.ts
var buildLandingSchema = function(param) {
    var origin = param.origin, destination = param.destination;
    return "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"WebPage\",\n  \"url\": \"https://bile-bile.kz/\",\n  \"name\": \"Купить дешевые ж/д билеты по направлению ".concat(origin, " - ").concat(destination, " | bile-bile.kz\",\n  \"description\": \"Bile-bile.kz ➤ дешевые ж/д билеты по направлению ").concat(origin, " - ").concat(destination, " ➤ Узнайте расписание, цены и покупайте железнодорожные билеты по выгодной цене.\",\n  \"publisher\": {\n    \"@type\": \"ProfilePage\",\n    \"name\": \"Bile-bile.kz - ТОО \xabNur-Kassa\xbb\"\n  }\n}");
};

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/routes.ts
var routesBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"Все станции по направлениям\",\n      \"item\": \"https://bile-bile.kz/napravleniya\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./components/shared/MetaHead/component.tsx

/* eslint-disable react/no-danger */ 



var SITE_URL = "https://bile-bile.kz" || 0;
var KZ_SITE_URL = "".concat(SITE_URL, "/kk");
var getSchemasByPage = function(page, extra) {
    if (page === 'home') return [
        homeBreadcrumbsSchema,
        orgSchema,
        webSchema
    ];
    if (page === 'faq') return [
        faqSchema,
        faqBreadcrumbsSchema
    ];
    if (page === 'covid') return [
        covidBreadcrumbsSchema
    ];
    if (page === 'contacts') return [
        contactsBreadcrumbsSchema
    ];
    if (page === 'search' || page === 'searchMulti') return [
        buildSearchSchema(extra)
    ];
    if (page === 'landing') return [
        buildLandingSchema(extra)
    ];
    if (page === 'routes') return [
        routesBreadcrumbsSchema
    ];
    return [];
};
var MetaHead = function(param) {
    var page = param.page, _extraParams = param.extraParams, extraParams = _extraParams === void 0 ? {} : _extraParams;
    var ref = (0,useTranslation/* default */.Z)('meta'), t = ref.t, lang = ref.lang;
    var router = (0,next_router.useRouter)();
    var title = t("".concat(page, ".title"), extraParams);
    var description = t("".concat(page, ".description"), extraParams);
    var pageSchemas = getSchemasByPage(page, extraParams);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }, "title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "meta-description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og-title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "og-website"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og-description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: "".concat(lang === 'ru' ? SITE_URL : KZ_SITE_URL).concat(router.asPath)
            }, "og-url"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: "".concat(SITE_URL, "/og-image.png")
            }, "og-image"),
            pageSchemas.map(function(schema, idx) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("script", {
                    id: "schema-".concat(idx),
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(JSON.parse(schema))
                    }
                }, schema);
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/shared/MetaHead/index.ts



/***/ }),

/***/ 41112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Icon/index.ts + 3 modules
var Icon = __webpack_require__(37033);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
;// CONCATENATED MODULE: ./components/ui/Breadcrumbs/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      overflow-x: scroll;\n      overflow-y: hidden;\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n      padding-bottom: 6px;\n\n      &::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      width: max-content;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-right: 8px;\n  align-items: center;\n  font-size: 14px;\n  color: ",
        ";\n  transition: all 0.3s ease;\n  &:last-child {\n    color: ",
        ";\n\n    .icon {\n      display: none;\n    }\n  }\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var ScrollWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5491b52-0"
})(_templateObject1(), function(param) {
    var mobileScrollable = param.mobileScrollable;
    return mobileScrollable && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5491b52-1"
})(_templateObject3(), function(param) {
    var mobileScrollable = param.mobileScrollable;
    return mobileScrollable && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});
var BreadcrumbLink = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a5491b52-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.palette.core.DEEP_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.MAIN;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
});

;// CONCATENATED MODULE: ./components/ui/Breadcrumbs/component.tsx






var Breadcrumbs = function(param) {
    var links = param.links, _mobileScrollable = param.mobileScrollable, mobileScrollable = _mobileScrollable === void 0 ? false : _mobileScrollable;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
        mobileScrollable: mobileScrollable,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            mobileScrollable: mobileScrollable,
            children: links.map(function(link) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(BreadcrumbLink, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: link.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: link.label
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            marginLeft: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                className: "icon",
                                color: theme.palette.core.DEEP_GRAY,
                                icon: theme.icons.core.BreadcrumbsArrow
                            })
                        })
                    ]
                }, link.url + link.label);
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ui/Breadcrumbs/index.ts



/***/ }),

/***/ 74628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ FAQPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/pages/static/content/faq.ts
var faq = __webpack_require__(6728);
// EXTERNAL MODULE: ./components/shared/FAQQuestions/index.ts + 2 modules
var FAQQuestions = __webpack_require__(38191);
// EXTERNAL MODULE: ./components/shared/MetaHead/index.ts + 11 modules
var MetaHead = __webpack_require__(82764);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Breadcrumbs/index.ts + 2 modules
var Breadcrumbs = __webpack_require__(41112);
// EXTERNAL MODULE: ./components/ui/Container/index.ts + 2 modules
var Container = __webpack_require__(96429);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./styles/mixins/page/pageWrapper.ts
var pageWrapper = __webpack_require__(25013);
;// CONCATENATED MODULE: ./components/pages/static/FAQ/styles.ts


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  span {\n    line-height: 1.3;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  grid-gap: 30px;\n  margin-top: 40px;\n  @media screen and (max-width: 860px) {\n    grid-template-columns: 1fr;\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 860px) {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  padding: 16px 16px 16px 32px;\n  border-radius: 12px;\n  background-color: ",
        ";\n  position: relative;\n  &:before {\n    position: absolute;\n    content: '';\n    top: 50%;\n    width: 8px;\n    height: 8px;\n    border-radius: 2px;\n    background-color: ",
        ";\n    left: 16px;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35e86752-0"
})(_templateObject(), (0,pageWrapper/* pageWrapper */.Y)(false));
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35e86752-1"
})(_templateObject1());
var Categories = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35e86752-2"
})(_templateObject2());
var CategoryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35e86752-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
});

;// CONCATENATED MODULE: ./components/pages/static/FAQ/component.tsx












var FAQPage = function() {
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var ref = (0,useTranslation/* default */.Z)('staticPages'), t = ref.t, lang = ref.lang;
    var ref1 = (0,react.useState)(1), activeCategoryId = ref1[0], setActiveCategoryId = ref1[1];
    var breadcrumbs = [
        {
            url: '/',
            label: t('breadcrumbs.home')
        },
        {
            url: '/faq',
            label: t('breadcrumbs.faq')
        }, 
    ];
    var categories = [
        {
            id: 1,
            title: t('faq.popularQuestions'),
            questions: faq/* popular */.d[lang]
        }, 
    ];
    var activeCategory = categories.find(function(category) {
        return category.id === activeCategoryId;
    }) || categories[0];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaHead/* MetaHead */.w, {
                page: "faq"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        marginTop: 32,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* Breadcrumbs */.O, {
                            links: breadcrumbs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        marginTop: 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            as: "h1",
                            typography: theme.typography.variants.title.H1,
                            children: t('faq.title')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories, {
                                children: categories.map(function(category) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CategoryItem, {
                                        "data-testid": "category",
                                        onClick: function() {
                                            return setActiveCategoryId(category.id);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            typography: theme.typography.variants.content.BOLD,
                                            color: theme.palette.secondary.MAIN,
                                            children: t('faq.popularQuestions')
                                        })
                                    }, category.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQQuestions/* FAQQuestions */.q, {
                                questions: activeCategory.questions,
                                title: activeCategory.title
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/pages/static/FAQ/index.ts


;// CONCATENATED MODULE: ./pages/faq.tsx
var __N_SSP = true;



/***/ }),

/***/ 25013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ pageWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50445);

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: ",
        "px;\n  position: relative;\n  min-height: calc(",
        ");\n  margin-bottom: ",
        "px;\n\n  @media screen and (max-width: 1180px) {\n    padding-top: 80px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var pageWrapper = function() {
    var useFullHeight = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, mt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90, mb = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 96;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), mt, useFullHeight ? '100vh' : 'calc(100vh - 90px)', mb);
};


/***/ }),

/***/ 76104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
/* 
(The MIT License)
Copyright (c) 2014-2021 Halász Ádám <adam@aimform.com>
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

//  Unique Hexatridecimal ID Generator
// ================================================

//  Dependencies
// ================================================
var pid = typeof process !== 'undefined' && process.pid ? process.pid.toString(36) : '' ;
var address = '';
if(false){ var i, networkInterfaces, mac, os; } 

//  Exports
// ================================================
module.exports = module.exports["default"] = function(prefix, suffix){ return (prefix ? prefix : '') + address + pid + now().toString(36) + (suffix ? suffix : ''); }
module.exports.process = function(prefix, suffix){ return (prefix ? prefix : '') + pid + now().toString(36) + (suffix ? suffix : ''); }
module.exports.time    = function(prefix, suffix){ return (prefix ? prefix : '') + now().toString(36) + (suffix ? suffix : ''); }

//  Helpers
// ================================================
function now(){
    var time = Date.now();
    var last = now.last || time;
    return now.last = time > last ? time : last + 1;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [671,774,888,179], function() { return __webpack_exec__(84160); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);